import { MBooking } from './BookingType'
import { MFacility } from './FacilityType'
import { MHotel } from './HotelType'
import { MImage } from './ImageType'
import { MPhoneNumber } from './PhoneNumberType'
import {
  MCancellationPolicy,
  MRoomRate,
  MRoom,
  MRoomItem,
  MRoomRates
} from './RoomType'

export {
  MBooking,
  MFacility,
  MHotel,
  MImage,
  MPhoneNumber,
  MCancellationPolicy,
  MRoomRate,
  MRoom,
  MRoomItem,
  MRoomRates,
}
